import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'webapp-compat-toast-alerts',
  template: ` <app-toast-alerts /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompatToastAlertsComponent {}
